import LoanList from './LoanList.container';

export default LoanList;
